export default __webpack_public_path__ + "static/media/man-writing-book-on-deskook-2194236-0.5f013a65.svg";